<template>
  <div class="c-betch g-container">
    <Breadcrumb class="m-bread">
      <BreadcrumbItem> <Icon type="ios-home-outline"></Icon> 项目 </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="logo-buffer"></Icon> 广告 </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="md-options"></Icon> 批量确认 </BreadcrumbItem>
    </Breadcrumb>

    <!-- 滚动区域 -->
    <div class="module-content" ref="container">
      <moduler :name="item.href" v-for="item in subModules" :key="item.id">
        <template v-if="item.href === 'submit_base'">
          <Row class="c-betch-head">
            <Col span="24">
              <span :style="{ marginRight: '12px' }"><b>批量计划配置</b></span>
              <span
                >共计：账号数 <span class="g-error-text">{{ lenAccount }}</span> 个，计划数
                <span class="g-error-text">{{ submitData.length }}</span> 条</span
              >
            </Col>
          </Row>
          <Tabs v-model="current" type="card" @on-click="changeTabs">
            <div class="c-submit-control g-pull-right" slot="extra">
              <el-input-number v-model="num" controls-position="right" :precision="0" :min="1" :max="50" />
              <Button type="primary" size="small" :disabled="!isBatch" @click="batchAdd">批量添加计划</Button>
              <Button size="small" @click="batchDel">批量删除</Button>
            </div>
            <TabPane v-for="(a, id) of bat_accounts" :label="accountTitle(a.name)" :name="a.name" :key="id"> </TabPane>
          </Tabs>
          <!-- 表格组件 -->
          <batch-table
            ref="rangeTable"
            :data="tableData"
            :loading="loading"
            :dynwords="dynwords"
            :isShowLdy="isShowLdy"
            :isLive="isLive"
            :bid-type="bidType"
            :isShowBudget="isShowBudget"
            @on-change="changeInputLen"
            @on-select="selectCheckBox"
            @on-select-all="selectAll"
            @on-batch="batchAll"
            @on-copy="copySubmit"
            @on-delete="delSubmit"
            @on-trend="appendTrend"
            @on-delete-trend="delTrend"
            @on-selection="changeSelection"
          ></batch-table>
        </template>
      </moduler>
    </div>

    <!-- 提交 -->
    <div class="c-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []"></error-pop>
        </Col>
        <Col span="12" class="c-btns-submit">
          <div class="c-betch-foot">
            <span class="b-state">广告计划状态</span>
            <i-switch v-model="batch.operation" size="large" true-value="enable" false-value="disable">
              <span slot="open">开启</span>
              <span slot="close">关闭</span>
            </i-switch>
          </div>
          <Button type="default" @click.stop="back">上一步</Button>
          <Button type="primary" :loading="loading" :disabled="disabled" @click.stop="submit">
            <span v-if="loading">提交中...</span>
            <span v-else>完成</span>
          </Button>
        </Col>
      </Row>
    </div>

    <!-- 批量添加弹窗 -->
    <set-batch
      v-model="model"
      :type="seType"
      :data="setData"
      :game-id="gameId"
      :account-id="accountId"
      :deliver-range="deliverRange"
      :bid-type="bidType"
      @on-select="asynSetBatch"
      @on-clear="clearSetData"
      @on-delete="deleteSetData"
    />

    <!-- 素材检测弹窗 -->
    <result-image v-model="ruleModel" :table-data="ruleData" :loading="ruling" @submit="postRequest" @advice="postAdvicest" />

    <!-- 创意组件弹窗 -->
    <creative-data v-model="creatCompModal" :account="curAccountId" :game-id="gameId" @on-select="selectCreativeComp"></creative-data>

    <!-- 图文创意选择框 -->
    <carouselSelectModal v-model="carouselModal" :account="curAccountId" @confirm="onCarouselConfirm"></carouselSelectModal>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import mixin from './mixin'
import { getSession, clearSession, setLocal, getLocalforage, clearAllLocalforage, getLocal } from '@/common/js/api'

import { isArray, isEmpty, trim, deepCopy, getByteLen, betweenTime, timeout } from '@/common/js/utils'

import BatchTable from './components/batch/batch-table.vue'
import SetBatch from './components/batch/set-batch'
import ResultImage from '@/components/convert/result-image'
import creativeData from '@/components/creative/creative-comp/creative-data.vue'
import carouselSelectModal from './components/batch/carousel-modal/carousel-select-modal.vue'

import { getCustomAudience, getPlayableList } from '@/api/toutiao.model'
import { addToutiaoBatchTaskSecond, getGoalsList, getJuLiangPlusGoalsList } from '@/api/toutiao.local.model'

// 批量广告组 反显广告账号
const findAccount = (child, parents) => {
  const findChild = parents.filter((ret) => {
    const childIds = ret.children.map((m) => m.id)
    return childIds.includes(child.id)
  })
  return findChild.shift() || {}
}

// 动态词
const dynwords = ['日期', '时间', '项目组名', '计划组名', '账号简称']

export default {
  name: 'batch',
  mixins: [mixin],
  components: { BatchTable, SetBatch, creativeData, ResultImage, carouselSelectModal },
  computed: {
    tableData() {
      return this.submitData
        .filter((ret) => ret.account.name === this.current)
        .map((ret) => {
          return {
            index: ret.id,
            plan: ret.plan.plan_name,
            // project: ret.project.name,
            // _project: ret.project._project,
            dynerr: ret.plan.dyn_err,
            dynpos: ret.plan.dyn_pos,
            account: ret.account.name,
            _account: ret.account._account,
            castTarget: ret.castTarget && ret.castTarget.name,
            _castTarget: ret.castTarget && ret.castTarget._castTarget,
            campaign: ret.campaign.name,
            _campaign: ret.campaign._campaign,
            target: ret.target.targetingName,
            _target: ret.target._target,
            retarget: ret.retarget.name,
            _retarget: ret.retarget._retarget,
            creative: ret.creative.campaign_name,
            _creative: ret.creative._creative,
            convert: ret.convert.name,
            _convert: ret.convert._convert,
            budget: ret.budget.value,
            _budget: ret.budget._budget,
            bid: ret.bid.out,
            _bid: ret.bid._bid,
            creativeComp: ret.creativeComp.name,
            _creativeComp: ret.creativeComp._creativeComp,
            nativeSetting: ret.nativeSetting.name,
            _nativeSetting: ret.nativeSetting._nativeSetting,
            nativeAnchor: ret.nativeAnchor.name,
            _nativeAnchor: ret.nativeAnchor._nativeAnchor,
            pagespec: ret.pagespec.name,
            _pagespec: ret.pagespec._pagespec,
            landingPage: ret.landingPage && ret.landingPage.name,
            _landingPage: ret.landingPage && ret.landingPage._landingPage,
            carouselMmaterial: ret.carouselMmaterial.name,
            _carouselMmaterial: ret.carouselMmaterial._carouselMmaterial
          }
        })
    },
    isBatch() {
      return this.tableData.length && this.tableData.length < this.max
    },
    lenAccount() {
      const account = new Set(this.submitData.map((ret) => ret.account.id))
      return account.size
    },
    isShowLdy() {
      return this.isAndroid || this.isMiniGame || this.appPromotionType === 'RESERVE'
    },
    accountTitle() {
      return (title) => {
        const len = this.submitData.filter((ret) => ret.account.name === title).length
        return `${title}${len ? '(' + len + ')' : ''}`
      }
    },
    subject() {
      return Number(getSession('subject')) || 1
    }
  },
  data() {
    return {
      landing_type: null, // 推广目的
      disabled: null,
      bidType: 'CUSTOM', // 广告组层级投放场景
      delivery_mode: '', // 广告组层级投放模式
      isShowBudget: true, // 创意层级的预算显示
      marketing_purpose: null,
      appPromotionType: '',
      auding: null,
      loading: null,
      carouselModal: false,
      model: null,
      ruling: null, // 加载动画
      ruleModel: null, // 素材检测弹窗
      ruleData: [], // 检测结果
      seType: '',
      setData: [], // 待添数据
      dynwords: dynwords,
      num: 1,
      max: 500,
      creatCompModal: false, // 创意组件弹窗
      creatIndex: null,
      submitData: [], // 公式结果
      selection: [], // 批量选择
      batch: {
        // batch_task_type: 1,
        operation: 'disable'
      },
      current: null,
      bat_accounts: [],
      gameId: null, // 游戏
      accountId: null,
      curAccountId: null,
      deliverRange: null,
      isAndroid: false, // 计划平台是否为安卓
      isMiniGame: false, // 计划平台是否为小程序
      isAppDown: false, // 计划下载方式是否为APP
      isLive: false // 是否是直播间
    }
  },
  methods: {
    async initSubmitData() {
      const batch_type = 2 // 批量广告组  2 批量账号
      const account_ids = getSession('ad_account_ids') || []
      const marketing_purpose = getSession('marketing_purpose') || ''
      const campaign_ids = getSession('campaign_ids') || []
      const targetings = getSession('targetings') || []
      // const creativeData = getSession('creative_params') || []
      const out_plan_info = getSession('outer_plan_params') || {}
      const plan_info = getSession('inner_plan_params') || {}
      const convert_params = getSession('convert_params') || {}
      const isLive = !!getSession('isLive') || null
      const bidType = out_plan_info.delivery_setting.bid_type

      let creativeData = []

      try {
        creativeData = await getLocalforage('creative_params')
      } catch (e) {
        console.log('get local plan info error output: ', e)
      }
      try {
        const { ch_platform_id, game_id, landing_type } = plan_info
        const { download_type, delivery_range, delivery_setting, delivery_mode, app_promotion_type } = out_plan_info
        this.isLive = isLive
        this.gameId = game_id
        this.isAndroid = ch_platform_id === 1
        this.isMiniGame = ch_platform_id === 3
        this.isAppDown = download_type === 'DOWNLOAD_URL'
        this.deliverRange = delivery_range
        this.landing_type = landing_type
        this.delivery_mode = delivery_mode
        this.appPromotionType = app_promotion_type
        // this.batch.batch_task_type = parseInt(batch_type)
        this.marketing_purpose = marketing_purpose
        this.bidType = bidType
        if (delivery_setting.budget_optimize_switch) this.isShowBudget = delivery_setting.budget_optimize_switch === 'OFF'
        if (isArray(account_ids) && account_ids.length) {
          this.bat_accounts = account_ids
          this.current = account_ids[0].name
          // this.accountId = account_ids[0].id
        }
        this.sources = {
          account: account_ids,
          campaign: campaign_ids,
          target: targetings,
          creative: creativeData
        }
        // 平铺广告计划
        if (parseInt(batch_type) === 1) {
          this.forSubmitGroup({ account_ids, campaign_ids, targetings, creativeData, plan_info, out_plan_info, convert_params })
        } else if (parseInt(batch_type) === 2) {
          this.forSubmitGroup({ account_ids, targetings, creativeData, plan_info, out_plan_info, convert_params }, true)
        }
      } catch (err) {
        console.error(err)
      }
    },
    forSubmitGroup(params, bool = false) {
      const _this = this
      let num = 0
      let group
      const {
        account_ids: account,
        campaign_ids: campaign,
        targetings: target,
        creativeData: creative,
        plan_info: plan,
        out_plan_info: out,
        convert_params: convert
      } = params
      if (!isArray(account) || !isArray(target) || !isArray(creative)) throw new Error('list must be the array')
      if (bool && !isArray(account)) throw new Error('list must be the array')

      if (bool) group = account
      // 批量账号
      else {
        // 批量广告组去掉不可能账号
        group = campaign.filter((ret) => {
          const met = findAccount(ret, account)
          return met && met.id
        })
      }
      this.curAccountId = account.id

      for (let i = 0; i < group.length; i++) {
        // const acountTaskNum = group.length * creative.length
        // const planName = `${plan.plan_name}_${i * acountTaskNum + 1}`
        if (num === _this.max) break
        for (let n = 0; n < target.length; n++) {
          if (num === _this.max) break
          for (let m = 0; m < creative.length; m++) {
            if (num === _this.max) break
            let submit = {
              id: num,
              account,
              campaign: bool ? {} : campaign,
              target: deepCopy(target[n]),
              creative: deepCopy(creative[m]),
              plan: Object.assign({}, plan, { plan_name: `${plan.plan_name}_${++num}` }),
              out,
              convert,
              budget: { value: creative[m].budget },
              bid: { out: Object.assign({}, creative[m], { deep_bid_type: out.delivery_setting.deep_bid_type }) }
            }

            // 自动投放出价设置，将项目的出价替换到广告，沿用之前的逻辑
            if (out.delivery_mode === 'PROCEDURAL') {
              submit.bid.out.cpa_bid = out.delivery_setting.cpa_bid
              submit.bid.out.budget = out.delivery_setting.budget
              submit.budget.value = out.delivery_setting.budget
              if (['ROI_COEFFICIENT', 'FIRST_AND_SEVEN_PAY_ROI', 'PER_AND_SEVEN_PAY_ROI'].includes(out.delivery_setting.deep_bid_type)) {
                submit.bid.out.roi_goal = out.delivery_setting.roi_goal
              }

              if (out.delivery_setting.deep_bid_type === 'DEEP_BID_MIN') {
                submit.bid.out.deep_cpabid = out.delivery_setting.deep_cpabid
              }
            }

            if (bool) submit = Object.assign(submit, { account: deepCopy(group[i]) })
            else {
              submit = Object.assign(submit, {
                account: deepCopy(findAccount(group[i], account)),
                campaign: deepCopy(group[i])
              })
            }
            // 生成项目名称
            // submit = Object.assign(submit, {
            //   project: {
            //     name: this.subject === 1 ? submit.plan.plan_name : planName
            //   }
            // })
            // 生成人群包
            const { audiences } = deepCopy(target[n]).targetingParam
            if (isArray(audiences)) {
              const idx = audiences.findIndex((_) => _.account_id === submit.account.id)
              const { retargeting_tags_include, retargeting_tags_exclude } = audiences[idx]
              const retarget_type = retargeting_tags_include.length || retargeting_tags_exclude.length
              submit = Object.assign(submit, {
                retarget: {
                  name: retarget_type ? '已配置' : '未配置人群',
                  audiences: deepCopy(audiences[idx])
                }
              })
            } else {
              submit = Object.assign(submit, {
                retarget: {
                  name: '未配置人群',
                  audiences: {}
                }
              })
            }
            // 生成媒体包
            const { mediaAudiences } = deepCopy(target[n]).targetingParam
            if (isArray(mediaAudiences)) {
              const idx = mediaAudiences.findIndex((_) => _.account_id === submit.account.id)
              submit = Object.assign(submit, {
                mediaAudiences: deepCopy(mediaAudiences[idx])
              })
            } else {
              submit = Object.assign(submit, {
                mediaAudiences: {}
              })
            }
            if (isArray(convert)) {
              let convertName = '请配置事件管理优化目标'
              const idx = convert.findIndex((_) => _.accountId === submit.account.id)
              if (idx > -1) {
                const { external_action, deep_external_action } = deepCopy(convert[idx])
                convertName = `${this.convType(external_action)}${this.convDeepType(deep_external_action)}`
              }
              // 匹配转化追踪
              submit = Object.assign(submit, {
                convert: Object.assign(
                  {
                    name: convertName
                  },
                  deepCopy(convert[idx])
                )
              })
            } else {
              // 不可配置转化
              submit = Object.assign(submit, {
                convert: Object.assign(
                  {
                    name: '不可配置事件管理优化目标'
                  },
                  convert
                )
              })
            }

            if (this.isShowLdy) {
              // 生成落地页
              submit = Object.assign(submit, {
                landingPage: {
                  accounts: [submit.account],
                  name: '请配置落地页',
                  web_url_material_list: [''] // 落地页链接
                }
              })
            }

            // 图文
            submit = Object.assign(submit, {
              carouselMmaterial: {
                accounts: [submit.account],
                name: '请配置图文',
                carousel_material_list: []
              }
            })

            if (this.isLive) {
              // 生成投放目标
              submit = Object.assign(submit, {
                castTarget: {
                  aweme_id: '',
                  name: '请配置投放目标',
                  castType: 'LIVE',
                  convert_type: 'AD_CONVERT_SOURCE_TYPE_SDK',
                  external_action: '',
                  is_feed_and_fav_see: true,
                  accountId: submit.account.id
                }
              })
            }
            // 生成创意组件
            submit = Object.assign(submit, {
              creativeComp: {
                name: '未配置创意组件',
                playable: {}
              }
            })
            // 生成原生广告
            submit = Object.assign(submit, {
              nativeSetting: {
                name: '未配置推广身份',
                awemeIdentity: 'ACCOUNT',
                aweme_id: '',
                accountId: submit.account.id,
                is_feed_and_fav_see: 'ON',

                creative_mode: submit.creative.creative_mode, // 是否开启抖音授权视频组件
                aweme_video_user_id: '', // 达人抖音号
                aweme_video_list: [] // 选中的抖音达人视频
              }
            })
            // 生成原生锚点
            submit = Object.assign(submit, {
              nativeAnchor: {
                name: '未配置原生锚点',
                anchor_related_type: 'OFF',
                anchor_id: '',
                accountId: submit.account.id,
                android_package_name: submit.plan.ch_platform_id === 1 ? submit.plan.package : null,
                ios_package_name: submit.plan.ch_platform_id === 2 ? submit.plan.package : null
              }
            })
            // 生成试玩素材页
            submit = Object.assign(submit, {
              pagespec: {
                name: '未配置试玩素材',
                playable: {}
              }
            })
            _this.submitData.push(submit)
            this.validTrend(num - 1)
          }
        }
      }
    },
    selectAll({ type, val }) {
      this.submitData
        .filter((ret) => ret.account.name === this.current)
        .forEach((ret) => {
          this.$set(ret[type], `_${type}`, val)
        })
    },
    selectCheckBox({ type, val }) {
      const [index, bool] = val
      const idx = this.submitData.findIndex((ret) => ret.id === index)
      this.$set(this.submitData[idx][type], `_${type}`, bool)
    },
    changeInputLen(val) {
      const [index, value] = val
      const idx = this.submitData.findIndex((ret) => ret.id === index)
      this.$set(this.submitData[idx].plan, 'plan_name', value)
      // if (this.subject === 1) {
      //   this.$set(this.submitData[idx].project, 'name', value)
      // } else {
      //   if (index === this.tableData[0].index) {
      //     this.submitData.forEach((s, i) => {
      //       if (this.tableData[0].account === this.submitData[i].account.name) this.$set(this.submitData[i].project, 'name', value)
      //     })
      //   }
      // }
      this.validTrend(idx)
    },
    batchAll(val) {
      const [type, index] = val
      const idx = this.submitData.findIndex((ret) => ret.id === index)
      if (typeof index === 'number' && idx > -1) {
        // 单项修改
        const filter = this.submitData[idx]
        const account = filter.account.id
        const convert = filter.convert
        this.filters = [filter]
        if (type === 'retarget' || type === 'convert' || type === 'pagespec') {
          if (typeof account !== 'number') {
            this.$Message.error('请先设置广告账号')
            return
          }
          if (type === 'convert' && !convert.isExists) {
            this.$Message.error('不可配置事件管理优化目标类型，请勿配置')
            return
          }
          if (type === 'retarget') this.getAudienceData(account, type)
          else if (type === 'pagespec') this.getPagespecData(account, type)
          else this.getConverterData(convert, type)
        } else if (type === 'budget') {
          const [, , budget] = val
          const { cpa_bid } = filter.bid.out
          const outBid = cpa_bid
          if (budget < outBid) this.$Message.error('预算不能小于出价')

          // v4.24.1 一对多项目层级的参数，根据定向包、当前账号来对同项目的广告统一修改预算
          if (this.subject === 2 && this.delivery_mode === 'PROCEDURAL') {
            this.submitData.forEach((row) => {
              const isCurrAccount = row.account.name === this.current
              if (isCurrAccount && row.target.targetingName === filter.target.targetingName) {
                this.$set(row, 'budget', { value: budget })
              }
            })
          } else {
            this.$set(filter, 'budget', { value: budget })
          }
        } else if (type === 'bid') {
          const deepOut = deepCopy(filter[type].out)
          this.setData = Object.assign(deepOut, { budget: filter.budget.value })
          this.model = true // 弹窗
          this.seType = type
        } else if (type === 'castTarget') {
          this.setData = deepCopy(filter[type])
          this.model = true // 弹窗
          this.seType = type
        } else if (type === 'landingPage') {
          this.setData = deepCopy(filter[type])
          this.model = true // 弹窗
          this.seType = type
        } else if (type === 'carouselMmaterial') {
          this.curAccountId = account
          this.carouselModal = true // 图文弹窗

          // this.setData = deepCopy(filter[type])
          // this.seType = type
        } else if (type === 'creativeComp') {
          const { inventory_type, inventory } = this.submitData[index].creative
          const noFeed = inventory === 'POSITION_MEDIA' && !inventory_type.includes('INVENTORY_AWEME_FEED')
          if (this.deliverRange === 'UNION' || noFeed) {
            this.$Message.error('不可配置创意组件，请勿配置')
            return
          }
          this.setData = deepCopy(filter[type])
          this.curAccountId = account
          this.creatCompModal = true // 弹窗
          this.creatIndex = index
          this.seType = type
        } else if (type === 'nativeSetting') {
          this.setData = deepCopy(filter[type])
          this.model = true // 弹窗
          this.seType = type
        } else if (type === 'nativeAnchor') {
          if (!['AWEME', 'AWEME_VIDEO'].includes(filter.nativeSetting.awemeIdentity)) {
            this.$Message.error('推广身份为抖音号时才可配置原生锚点')
            return
          }
          this.setData = deepCopy(filter[type])
          this.model = true // 弹窗
          this.seType = type
        } else {
          if (type === 'campaign') this.setData = this.sources[type].filter((ret) => ret.account === account)
          else this.setData = this.sources[type]
          this.model = true // 弹窗
          this.seType = type
        }
      } else {
        // 批量修改
        const filters = this.submitData.filter((ret) => ret[type][`_${type}`])
        if (!filters.length) {
          this.$Message.error('至少选择一项')
          return
        }
        // 批量广告组与人群包统一账号
        const account = filters[0].account.id
        const convert = filters[0].convert
        const sameAccount = filters.every((ret) => ret.account.id === account)
        if (['campaign', 'retarget', 'convert', 'pagespec'].includes(type) && !sameAccount) {
          this.$Message.error('请选择同一个账号的广告计划进行批量设置')
          return
        }
        if (type === 'convert' && !convert.isExists) {
          this.$Message.error('不可配置事件管理优化目标类型，请勿配置')
          return
        }
        if (type === 'creativeComp') {
          const notAllowCard = this.submitData.some((ret) => {
            const { inventory_type, inventory } = ret.creative
            const noFeed = inventory === 'POSITION_MEDIA' && !inventory_type.includes('INVENTORY_AWEME_FEED')
            return noFeed
          })
          if (notAllowCard || this.deliverRange === 'UNION') {
            this.$Message.error('不可配置创意组件，请勿配置')
            return
          }
        }
        this.filters = filters
        if (type === 'retarget') this.getAudienceData(account, type)
        else if (type === 'pagespec') this.getPagespecData(account, type)
        else if (type === 'convert') this.getConverterData(convert, type)
        else if (type === 'creativeComp') {
          this.curAccountId = account
          this.creatCompModal = true
          this.creatIndex = null
        } else {
          if (type === 'campaign') this.setData = this.sources[type].filter((ret) => ret.account === filters[0].account.id)
          else if (type === 'budget') this.setData = [{ value: 0 }]
          else if (type === 'bid') {
            const deepOut = deepCopy(filters[0][type].out)
            this.setData = Object.assign(deepOut, { budget: filters[0].budget.value })
          } else if (type === 'landingPage') this.setData = deepCopy(filters[0][type])
          else if (type === 'carouselMmaterial') {
            this.curAccountId = account
            this.carouselModal = true // 图文弹窗
            return
          } else if (type === 'castTarget') this.setData = deepCopy(filters[0][type])
          else if (type === 'nativeSetting') {
            // 标记是否批量设置，用于在弹窗组件里禁用抖音达人视频
            this.setData = deepCopy({ ...filters[0][type], batch: true })
          } else if (type === 'nativeAnchor') {
            if (!filters.every((f) => ['AWEME', 'AWEME_VIDEO'].includes(f.nativeSetting.awemeIdentity))) {
              this.$Message.error('推广身份为抖音号时才可配置原生锚点')
              return
            }
            this.setData = deepCopy(filters[0][type])
          } else this.setData = this.sources[type]
          this.model = true // 弹窗
          this.seType = type
        }
      }
    },
    getAudienceData(account, type) {
      this.$Spin.show()
      this.auding = true
      getCustomAudience({ account }).then((data) => {
        this.auding = false
        this.$Spin.hide()
        if (data && data.success) {
          if (isArray(data.models.retData)) {
            // 单个显示
            let includes = []
            let excludes = []
            if (isArray(this.filters) && this.filters.length === 1) {
              const [filter] = this.filters
              if (filter.retarget.audiences && isArray(filter.retarget.audiences.retargeting_tags_include)) {
                includes = filter.retarget.audiences.retargeting_tags_include
              }
              if (filter.retarget.audiences && isArray(filter.retarget.audiences.retargeting_tags_exclude)) {
                excludes = filter.retarget.audiences.retargeting_tags_exclude
              }
            }
            this.setData = data.models.retData.map((ret) => {
              let select
              includes.includes(ret.custom_audience_id) && (select = 'include')
              excludes.includes(ret.custom_audience_id) && (select = 'exclude')
              return {
                id: ret.custom_audience_id,
                name: ret.name,
                source: ret.source,
                select
              }
            })
            this.model = true // 弹窗
            this.seType = type
          }
        } else this.setData = []
      })
    },
    getConverterData(convert, type) {
      if (!convert) {
        this.$Message.error('请求事件管理优化目标信息错误')
        return
      }
      const { accountId, platform } = convert
      // const params = {
      //   ad_account_id: accountId,
      //   landing_type: this.landing_type,
      //   marketing_purpose: 'CONVERSION',
      //   asset_type: 'APP',
      //   package_name: getSession('inner_plan_params').package,
      //   app_type: platform === 1 ? 'ANDROID' : 'IOS'
      // }
      this.$Spin.show()
      this.auding = true

      const params = {
        ad_account_id: accountId,
        landing_type: this.landing_type,
        asset_type: this.landing_type === 'APP' ? 'APP' : 'ORANGE',
        ad_type: 'ALL',
        package_name: getSession('inner_plan_params').package
      }

      if (this.appPromotionType === 'RESERVE') {
        params.app_promotion_type = this.appPromotionType
      }

      // 当 asset_type = APP时必填
      if (params.asset_type === 'APP') {
        params.app_type = platform === 1 || platform === 3 ? 'ANDROID' : 'IOS'
      }
      // 获取可用优化目标 媒体接口 https://open.oceanengine.com/labels/7/docs/1740944984250381
      getJuLiangPlusGoalsList([params]).then((data) => {
        this.auding = false
        this.$Spin.hide()
        if (isArray(data)) {
          this.setData = data
          this.model = true // 弹窗
          this.seType = type
        } else this.setData = []
      })
      // getGoalsList([params]).then((data) => {
      //   this.auding = false
      //   this.$Spin.hide()
      //   if (isArray(data)) {
      //     this.setData = data
      //     this.model = true // 弹窗
      //     this.seType = type
      //   } else this.setData = []
      // })
    },
    getPagespecData(account, type) {
      this.$Spin.show()
      getPlayableList({ ad_account_id: account }).then((data) => {
        if (typeof data !== 'symbol') this.$Spin.hide()
        if (isArray(data)) {
          this.setData = data.map((ret, index) => {
            ret.index = index
            return ret
          })
          this.model = true // 弹窗
          this.seType = type
        } else this.setData = []
      })
    },
    deleteSetData({ type, name }) {
      if (type === 'retarget') {
        const index = this.setData.findIndex((ret) => ret.id === name)
        if (index > -1) {
          this.$set(this.setData[index], 'select', null)
        }
      }
    },
    clearSetData({ type }) {
      if (type === 'retarget') {
        this.setData.forEach((item) => {
          this.$set(item, 'select', null)
        })
      }
    },
    appendTrend(val) {
      const [index, word, selectionStart] = val
      const idx = this.submitData.findIndex((ret) => ret.id === index)
      const title = deepCopy(this.submitData[idx].plan.plan_name)
      const prefix = title.substring(0, selectionStart)
      const suffix = title.substring(selectionStart)
      const value = `${prefix}{${word}}${suffix}`
      if (title.indexOf(word) > -1) {
        this.$Message.error('不能使用重复的动态词')
        return
      }
      this.$set(this.submitData[idx].plan, 'plan_name', value)
      this.validTrend(idx)
    },
    delTrend(index) {
      this.validTrend(index)
    },
    selectCreativeComp(val) {
      if (this.creatIndex) {
        this.$set(this.filters[0], 'creativeComp', {
          name: val.component_name,
          component_id: val.component_id
        })
      } else {
        this.filters.forEach((ret) => {
          this.$set(ret, 'creativeComp', {
            name: val.component_name,
            component_id: val.component_id
          })
        })
      }
    },
    changeTabs() {
      this.submitData.forEach((ret) => {
        ;[
          'account',
          'campaign',
          'target',
          'creative',
          'retarget',
          'convert',
          'budget',
          'bid',
          'creativeComp',
          'nativeSetting',
          'nativeAnchor',
          'pagespec',
          'landingPage'
        ].forEach((type) => {
          this.$set(ret[type], `_${type}`, false)
        })
      })
    },
    // 动态词验证
    validTrend(index) {
      if (typeof index !== 'number') return
      const { plan_name } = deepCopy(this.submitData[index].plan)
      if (isEmpty(plan_name)) return
      let dynErr = ''
      const regexp = /({[\u4e00-\u9fa5]{2,}})/g
      const values = plan_name.match(regexp)
      const count = (str, cut) => {
        if (typeof str !== 'string') return 0
        return str.split('').filter((ret) => ret === cut).length
      }
      if (count(plan_name, '{') !== count(plan_name, '}')) {
        dynErr = '动态词包格式错误'
      } else if (plan_name.replace(regexp, '').includes('{') || plan_name.replace(regexp, '').includes('{')) {
        dynErr = '动态词包标识{}不允许作为内容出现'
      } else if (isArray(values) && values.some((ret) => !this.dynwords.map((met) => `{${met}}`).includes(ret))) {
        dynErr = '动态词包不存在'
      } else if (isArray(values) && values.some((ret, i) => values.indexOf(ret) !== i)) {
        dynErr = '动态词包不能存在相同'
      }
      // 动态词位置
      let dynPos = []
      if (isArray(values)) {
        dynPos = values
          .filter((ret) => this.dynwords.map((met) => `{${met}}`).includes(ret))
          .map((m) => {
            const min = plan_name.indexOf(m)
            return [min, min + m.length]
          })
      }
      this.$set(this.submitData[index].plan, 'dyn_pos', dynPos)
      this.$set(this.submitData[index].plan, 'dyn_err', dynErr)
    },
    /**
     * @description: 图文创意选择确认
     */
    onCarouselConfirm(list) {
      this.filters.forEach((f) => {
        this.$set(f, 'carouselMmaterial', {
          ...f.carouselMmaterial,
          carousel_material_list: list,
          name: '已配置图文'
        })
        this.$set(f.carouselMmaterial, '_carouselMmaterial', false)
      })
    },
    asynSetBatch({ type, index }) {
      // 批量操作结果
      if (
        typeof type !== 'string' ||
        (!['bid', 'pagespec', 'landingPage', 'castTarget', 'nativeSetting', 'nativeAnchor'].includes(type) && typeof index !== 'number')
      ) {
        this.$Message.error('选择的类型或是值错误')
        return
      }

      if (type === 'retarget') {
        // 人群包修改
        const includes = []
        const excludes = []
        const account = this.filters[0].account.id
        const retarget_type = this.setData.some((ret) => {
          return ret.select === 'include' || ret.select === 'exclude'
        })
        if (retarget_type) {
          const include = this.setData.filter((met) => met.select === 'include').map((ret) => ret.id)
          const exclude = this.setData.filter((met) => met.select === 'exclude').map((ret) => ret.id)
          includes.push(...include)
          excludes.push(...exclude)
        }
        // 批量更改定向
        this.filters.forEach((ret) => {
          const re_name = excludes.length || includes.length ? '已配置' : '未配置人群'
          const re_audiences = { account_id: account, retargeting_tags_exclude: excludes, retargeting_tags_include: includes }
          this.$set(ret, 'retarget', {
            name: re_name,
            audiences: re_audiences
          })
          this.$set(ret[type], '_retarget', false)
        })
      } else if (type === 'convert') {
        // 转化
        const nVal = deepCopy(this.setData[index])
        if (!nVal || !nVal.isExists) {
          this.$Message.error('选中事件管理优化目标数据不可用')
          return
        }
        const { external_action, deep_external_action } = nVal
        nVal.name = `${this.convType(external_action)}${this.convDeepType(deep_external_action)}`
        nVal._convert = false

        // v4.24.1 一对多项目层级的参数，根据定向包来对同项目的广告统一修改转化
        // v4.33补充：一对多项目，使用同一个转化参数，单个修改的时候会一起修改；
        // 与出价、预算不同，不需要判断是否自动投放
        if (this.subject === 2) {
          const checkedRowTargetNames = this.filters.map((row) => row.target.targetingName)
          this.submitData.forEach((row) => {
            const isCurrAccount = row.account.name === this.current
            if (isCurrAccount && checkedRowTargetNames.includes(row.target.targetingName)) {
              this.$set(row, 'convert', Object.assign({}, row.convert, nVal))
            }
          })
        } else {
          this.filters.forEach((ret) => {
            this.$set(ret, 'convert', Object.assign({}, ret.convert, nVal))
          })
        }
      } else if (type === 'account') {
        // 账号修改
        // 批量更改账号，广告组，人群包
        const old_account = this.filters[0].account.id
        this.filters.forEach((ret) => {
          const account = deepCopy(this.setData[index])
          if (account.id !== old_account) {
            this.$set(ret, 'campaign', {})
            this.$set(ret, 'retarget', {
              name: '未配置人群',
              audiences: { account_id: account.id, retargeting_tags_exclude: [], retargeting_tags_include: [] }
            })
            this.$set(ret, 'pagespec', { name: '未配置试玩素材', playable: {} })
            this.$set(ret, type, account)
          }
          this.$set(ret[type], `_${type}`, false)
        })
      } else if (type === 'budget') {
        const { bid, cpa_bid, pricing } = this.filters[0].bid.out
        const outBid = pricing === 'PRICING_OCPM' ? cpa_bid : bid
        if (!index) {
          this.$Message.error('预算不能设置为空或‘0’')
          return
        }
        if (index < 300) {
          this.$Message.error('预算不能小于300')
          return
        }
        if (index < outBid) {
          this.$Message.error('预算不能小于出价')
          return
        }
        // v4.24.1 一对多项目层级的参数，根据定向包来对同项目的广告统一修改
        // 批量同步同项目预算
        if (this.subject === 2 && this.delivery_mode === 'PROCEDURAL') {
          const checkedRowTargetNames = this.filters.map((row) => row.target.targetingName)
          this.submitData.forEach((row) => {
            const isCurrAccount = row.account.name === this.current
            if (isCurrAccount && checkedRowTargetNames.includes(row.target.targetingName)) {
              this.$set(row, 'budget', { value: index })
            }
          })
        } else {
          this.filters.forEach((ret) => {
            this.$set(ret, 'budget', { value: index })
            this.$set(ret.budget, '_budget', false)
          })
        }
      } else if (type === 'bid') {
        // v4.24.1 一对多项目层级的参数，根据定向包来对同项目的广告统一修改出价
        // 出价只有是自动投放时，统一针对定向包修改
        if (this.subject === 2 && this.delivery_mode === 'PROCEDURAL') {
          this.submitData.forEach((row) => {
            const isCurrAccount = row.account.name === this.current
            if (isCurrAccount) {
              this.filters.forEach((_row) => {
                const { out } = deepCopy(_row[type])
                Object.assign(out, index)
                if (_row.target.targetingName === row.target.targetingName) {
                  this.$set(row, type, { out })
                  this.$set(_row[type], `_${type}`, false)
                }
              })
            }
          })
        } else {
          this.filters.forEach((ret) => {
            const { out } = deepCopy(ret[type])
            Object.assign(out, index)
            this.$set(ret, type, { out })
            this.$set(ret[type], `_${type}`, false)
          })
        }
      } else if (type === 'landingPage') {
        this.filters.forEach((ret) => {
          const { web_url_material_list } = index
          const out = deepCopy(ret[type])
          Object.assign(out, index, { name: web_url_material_list.some((ret) => isEmpty(ret)) ? '请配置落地页' : '已配置' })
          this.$set(ret, type, out)
          this.$set(ret[type], `_${type}`, false)
        })
      } else if (type === 'castTarget') {
        this.filters.forEach((ret) => {
          const { aweme_id, external_action, convert_id } = index
          const out = deepCopy(ret[type])
          if (external_action) Object.assign(out, index, { name: !aweme_id || !external_action ? '请配置投放目标' : '已配置' })
          else Object.assign(out, index, { name: !aweme_id || !convert_id ? '请配置投放目标' : '已配置' })
          this.$set(ret, type, out)
          this.$set(ret[type], `_${type}`, false)
        })
      } else if (type === 'nativeSetting') {
        this.filters.forEach((ret) => {
          const { aweme_id, awemeIdentity, aweme_video_list } = index
          const out = deepCopy(ret[type])

          let name = '未配置推广身份'
          if (aweme_id || aweme_video_list?.length) name = '已配置'

          Object.assign(out, index, { name })

          if (awemeIdentity === 'ACCOUNT') {
            // 还原锚点
            ret.nativeAnchor = {
              name: '未配置原生锚点',
              anchor_related_type: 'OFF',
              anchor_id: '',
              anchor_name: '',
              accountId: ret.nativeAnchor.accountId
            }
          }
          this.$set(ret, type, out)
          this.$set(ret[type], `_${type}`, false)
        })
      } else if (type === 'nativeAnchor') {
        this.filters.forEach((ret) => {
          const { anchor_related_type } = index
          const out = deepCopy(ret[type])
          Object.assign(out, index, { name: anchor_related_type === 'OFF' ? '未配置原生锚点' : '已配置' })
          this.$set(ret, type, out)
          this.$set(ret[type], `_${type}`, false)
        })
      } else if (type === 'pagespec') {
        let playable
        if (typeof index === 'number') {
          const nVal = deepCopy(this.setData[index])
          playable = { name: nVal.playable_url, playable: nVal }
        } else {
          playable = { name: '未配置试玩素材', playable: {} }
        }
        this.filters.forEach((ret) => {
          this.$set(ret, type, deepCopy(playable))
          this.$set(ret[type], `_${type}`, false)
        })
      } else {
        const nVal = deepCopy(this.setData[index])
        if (!nVal) {
          this.$Message.error('找不到选中值数据')
          return
        }
        this.filters.forEach((ret) => {
          this.$set(ret, type, deepCopy(nVal))
          this.$set(ret[type], `_${type}`, false)
        })
      }
    },
    copySubmit(index) {
      if (!this.isBatch) {
        this.$Message.error('计划数已达到了上限')
        return
      }
      const len = this.submitData.length
      const unshife = deepCopy(this.submitData.filter((ret) => ret.account.name === this.current)[index])
      const { id } = this.submitData[len - 1]
      unshife.id = id + 1
      unshife.plan = Object.assign(unshife.plan, { plan_name: `${unshife.plan.plan_name}复制` })
      // unshife.project = Object.assign(unshife.project, { name: `${unshife.project.name}${this.subject === 1 ? '复制' : ''}` })
      this.submitData.push(unshife)
    },
    delSubmit(id) {
      const index = this.submitData.findIndex((ret) => ret.id === id)
      this.submitData.splice(index, 1)
    },
    changeSelection(val) {
      this.selection = val
    },
    getOperation() {
      const account = Cookies.get('ch_op_id') || ''
      const storage = getLocal('operation')
      const operation = storage && account && storage[account] ? storage[account] : this.batch.operation
      this.$set(this.batch, 'operation', operation)
    },
    setOperatorStorage(name, value) {
      const account = Cookies.get('ch_op_id')
      const storage = getLocal(name) || {}
      if (account) {
        storage[account] = value
        setLocal(name, storage)
      }
    },
    sourceType(cell) {
      return cell === 'AD_CONVERT_SOURCE_TYPE_APP_DOWNLOAD' ? '应用下载API' : '应用下载SDK'
    },
    convType(cell) {
      if (cell === 'AD_CONVERT_TYPE_ACTIVE') return '激活'
      else if (cell === 'AD_CONVERT_TYPE_PAY') return '付费'
      else if (cell === 'AD_CONVERT_TYPE_ACTIVE_REGISTER') return '注册'
      else if (cell === 'AD_CONVERT_TYPE_GAME_ADDICTION') return '关键行为'
      else if (cell === 'AD_CONVERT_TYPE_FORM') return '表单提交'
      else if (cell === 'AD_CONVERT_TYPE_NOTIFY_FORM') return '预约表单'
      else if (cell === 'AD_CONVERT_TYPE_NOTIFY_DOWNLOAD') return '预约下载'
    },
    convDeepType(cell) {
      if (cell === 'AD_CONVERT_TYPE_ACTIVE_REGISTER') return '，深度转化，注册'
      else if (cell === 'AD_CONVERT_TYPE_PAY') return '，深度转化，付费'
      else if (cell === 'AD_CONVERT_TYPE_PURCHASE_ROI') return '，深度转化，付费ROI'
      else if (cell === 'AD_CONVERT_TYPE_NEXT_DAY_OPEN') return '，深度转化，次留'
      else return '，深度转化，无'
    },
    batchAdd() {
      const len = this.submitData.length
      const more = this.max - this.tableData.length
      const num = more > 50 ? this.num : more % 50
      const table = this.submitData.filter((ret) => ret.account.name === this.current).pop()
      if (!table || !len) {
        this.$Message.error('无计划不能批量复制！')
        return
      }
      const index = this.submitData.findIndex((ret) => ret.id === table.id)
      const { id } = this.submitData[len - 1]
      const {
        account,
        campaign,
        target,
        retarget,
        creative,
        plan,
        // project,
        dynerr,
        out,
        convert,
        budget,
        bid,
        creativeComp,
        nativeSetting,
        nativeAnchor,
        pagespec,
        landingPage,
        carouselMmaterial,
        castTarget,
        mediaAudiences
      } = deepCopy(this.submitData[index])
      const { plan_name } = plan
      for (let i = 0; i < num; i++) {
        this.submitData.push({
          id: id + i + 1,
          account: deepCopy(account),
          campaign: deepCopy(campaign),
          target: deepCopy(target),
          retarget: deepCopy(retarget),
          creative: deepCopy(creative),
          out: deepCopy(out),
          convert: deepCopy(convert),
          budget: deepCopy(budget),
          bid: deepCopy(bid),
          creativeComp: deepCopy(creativeComp),
          nativeSetting: deepCopy(nativeSetting),
          nativeAnchor: deepCopy(nativeAnchor),
          pagespec: deepCopy(pagespec),
          landingPage: deepCopy(landingPage),
          carouselMmaterial: deepCopy(carouselMmaterial),
          castTarget: deepCopy(castTarget),
          dynerr: deepCopy(dynerr),
          mediaAudiences: deepCopy(mediaAudiences),
          plan: Object.assign({}, plan, { plan_name: `${plan_name}_${i + 1}` })
          // project: this.subject === 1 ? Object.assign({}, project, { name: `${plan_name}_${i + 1}` }) : deepCopy(project)
        })
      }
    },
    batchDel() {
      const len = this.selection.length
      if (!len) {
        this.$Message.error('至少选中一条计划')
        return
      }
      this.$Modal.confirm({
        title: '系统提示',
        content: `当前选中${len}条计划，确认删除？`,
        onOk: () => {
          const ids = this.selection.map((ret) => ret.index)
          this.submitData = this.submitData.filter((ret) => !ids.includes(ret.id))
        }
      })
    },
    customVaild(data) {
      const err = []
      // 导出title组
      data.forEach((ret) => {
        const title = ret.plan.plan_name
        const dyneer = ret.plan.dyn_err
        const landingPage = this.isShowLdy && !ret.landingPage.web_url_material_list.some((ret) => isEmpty(ret))
        // const castTarget = this.isLive && (ret.castTarget.aweme_id && (ret.castTarget.external_action || ret.castTarget.convert_id))
        const awemeOnlyVideo = !(
          ret.target.targetingParam.inventory_type?.length === 1 &&
          ret.target.targetingParam.inventory_type.includes('INVENTORY_AWEME_FEED') &&
          ret.creative.image_list.some((ret) =>
            ['CREATIVE_IMAGE_MODE_SMALL', 'CREATIVE_IMAGE_MODE_LARGE', 'CREATIVE_IMAGE_MODE_LARGE_VERTICAL'].includes(ret.image_mode)
          )
        )
        const idx = err.findIndex((ret) => ret.title === trim(title))
        if (idx > -1) err[idx].ids.push(ret.id)
        else err.push({ title: trim(title), dyneer, landingPage, awemeOnlyVideo, ids: [ret.id] })
      })

      const empties = err.filter((ret) => isEmpty(ret.title))
      const sames = err.filter((ret) => ret.title && ret.ids.length > 1)
      const mores = err.filter((ret) => {
        let len = getByteLen(ret.title)
        const regexp = /({[\u4e00-\u9fa5]{2,}})/g
        const values = ret.title.match(regexp)

        if (isArray(values)) {
          values.forEach((ret) => {
            ret === '{项目组名}' && (len += 11)
            ret === '{计划组名}' && (len += 11)
          })
        }
        return len > 90
      })
      const dyerrors = err.filter((ret) => ret.dyneer)
      const awemeMater = err.filter((ret) => !ret.awemeOnlyVideo)
      let landingPages = []
      if (this.isShowLdy) landingPages = err.filter((ret) => !ret.landingPage)
      return [empties, sames, mores, dyerrors, landingPages, awemeMater]
    },
    budgetVaild(data) {
      const { start_time, end_time, ad, budget_mode } = data[0].out // cpa_bid, bid,
      const day = betweenTime(start_time, end_time) // 投放天数
      let lowBudget // 最低预算
      let totalBudget // 最低总预算
      // 预算
      if (ad === 'SHOW') {
        lowBudget = 100
        totalBudget = day * lowBudget
      } else {
        lowBudget = 300
        totalBudget = day * lowBudget
      }
      // 预算设置
      if (budget_mode === 'BUDGET_MODE_DAY') {
        const list = data
          .map((met, i) => {
            met.id = [i + 1]
            return met
          })
          .filter((ret) => ret.budget.value < lowBudget || ret.budget.value > 9999999.99)
        return { name: '日预算', low: lowBudget, list }
      } else if (budget_mode === 'BUDGET_MODE_TOTAL') {
        const list = data
          .map((met, i) => {
            met.id = [i + 1]
            return met
          })
          .filter((ret) => ret.budget.value < totalBudget || ret.budget.value > 9999999.99)
        return { name: '总预算', low: totalBudget, list }
      }
    },
    submit() {
      // 多验证
      const errRes = this.customVaild(this.submitData)
      if (errRes.some((_) => _.length)) {
        // this.formErr = true
        // 提示错误改成弹出窗
        const content = errRes.map((ret, i) => {
          let profix = ''
          if (i === 1) profix = '广告计划名称不能相同'
          else if (i === 2) profix = '广告计划名称不能超过90个字符'
          else if (i === 3) profix = '广告计划名称中动态词规则错误'
          else if (i === 4) profix = '请配置落地页'
          else if (i === 5) profix = '版位仅选抖音短视频时，不能选择图片素材'
          else profix = '广告计划名称不能为空'
          if (isArray(ret) && ret.length) {
            const ids = ret.map((met) => met.ids.map((_) => _ + 1).join(',')).join(',')
            return `<p class="modal_content" style="word-break: break-all;">${profix}，请检查以下序号的广告计划：${ids}</p>`
          } else return ''
        })
        this.$Modal.error({
          title: '批量广告计划错误，请修改：',
          content: content.join('')
        })
        return // 如果错误中断
      }

      try {
        this.submitData.forEach((row) => {
          const hasMaterials = row.creative.image_list.length > 0
          const hasCarousels = row.carouselMmaterial.carousel_material_list.length > 0
          const { creative_mode } = row.creative
          const { aweme_video_list } = row.nativeSetting

          if (creative_mode === 2) {
            if (!aweme_video_list.length) {
              throw new Error(`计划：${row.plan.plan_name}，须配置达人视频素材`)
            }
          } else {
            // 校验是否配置视频、图片或图文素材
            if (!hasMaterials && !hasCarousels) {
              throw new Error(`计划：${row.plan.plan_name}，须配置创意素材`)
            }
          }
        })
      } catch (err) {
        console.log(err)
        this.$Modal.error({
          title: '批量广告计划错误，请修改：',
          content: err.message
        })
        return
      }

      // 验证预算总值
      // if (!this.bidType) {
      //   const { name, low, list } = this.budgetVaild(this.submitData)
      //   if (isArray(list) && list.length) {
      //     const ids = list.map(ret => ret.id + 1).join(',')
      //     this.$Modal.error({
      //       title: '批量广告计划错误，请修改：',
      //       content: `<p>${name}应大于或等于${low}元小于100000000元，请检查以下序号的广告计划：${ids}</p>`
      //     })
      //     return // 如果错误中断
      //   }
      // }

      this.postRequest()
    },
    postAdvicest() {
      const advs = this.ruleData.filter((ret) => ret.advice).map((ret) => ret.planId)
      this.postRequest(advs)
    },
    postRequest(advs) {
      this.ruleModel = false
      let submitData = this.submitData
      if (advs) submitData = this.submitData.filter((ret, id) => advs.includes(id))
      const params = Object.assign(this.batch, {
        planlist: submitData.map((ret) => {
          const { roi_goal, deep_bid_type, cpa_bid, deep_cpabid } = ret.bid.out || {}
          const { delivery_mode } = ret.out || {}
          const { inventory_catalog, inventory_type, union_video_type } = ret.target.targetingParam || {}
          const { external_action, deep_external_action, asset_ids } = ret.convert || {}
          const { image_ids, selling_points, app_name } = ret.creative || {}
          const { web_url_material_list } = ret.landingPage || {}
          const { plan_name } = ret.plan
          const { anchor_id, anchor_related_type, anchor_name } = ret.nativeAnchor || {}
          const { aweme_id, is_feed_and_fav_see, aweme_video_list, aweme_video_user_id, awemeIdentity } = ret.nativeSetting || {}
          const { carousel_material_list } = ret.carouselMmaterial || {}

          const creative_params = Object.assign({}, ret.creative, {
            budget: ret.budget.value,
            roi_goal,
            cpa_bid,
            deep_cpabid,
            product_info: {
              titles: [app_name],
              image_ids: [image_ids],
              selling_points
            }
          })

          // 添加预约场景落地页；子目的为预约时，安卓、ios需要填写
          if (ret.out.app_promotion_type === 'RESERVE') {
            creative_params.external_url_material_list = web_url_material_list
          } else {
            // Android应用下载详情页； 子目的为下载时，安卓、小程序需要填写
            creative_params.web_url_material_list = web_url_material_list
          }

          // 添加图文创意
          if (carousel_material_list && carousel_material_list.length) {
            creative_params.carousel_material_list = carousel_material_list.map((c) => ({ carousel_id: c.id }))
            // creative_params.carouselMmaterialDetails = carousel_material_list
          }

          // 推广身份：选择抖音达人视频时，添加达人视频
          creative_params.awemeIdentity = awemeIdentity
          if (awemeIdentity === 'AWEME_VIDEO' && aweme_video_list?.length) {
            const videolist = aweme_video_list.map((ret) => {
              return {
                item_id: ret.video_info.item_id,
                video_id: ret.video_info.video_id,
                video_cover_id: ret.video_info.video_cover_id,
                image_mode: ret.video_info.image_mode,
                auth_type: 'VIDEO_ITEM'
              }
            })
            creative_params.image_list = [] // 先清空掉之前的选择的常规创意
            creative_params.image_list.push(...videolist)

            creative_params.native_setting = {
              aweme_id: aweme_video_user_id,
              anchor_related_type: 'AUTO'
            }
          }

          let param = {
            inner_plan_params: ret.plan,
            outer_plan_params: Object.assign({}, ret.out, {
              name: plan_name,
              deep_external_action,
              external_action,
              asset_ids,
              delivery_range: {
                inventory_catalog,
                inventory_type,
                union_video_type
              }
            }),
            creative_params,
            // convert_params: ret.convert,

            targetings: ret.target
          }

          // 预约投放删除asset_ids
          if (ret.out.app_promotion_type === 'RESERVE') {
            delete param.outer_plan_params.asset_ids
          }
          // ios删除火山版位
          // if (ch_platform_id === 2 && inventory_type.includes('INVENTORY_HOTSOON_FEED') && isArray(param.outer_plan_params.delivery_range.inventory_type)) param.outer_plan_params.delivery_range.inventory_type = param.outer_plan_params.delivery_range.inventory_type.filter(ret => ret !== 'INVENTORY_HOTSOON_FEED')

          // 深度出价参数处理
          param.outer_plan_params.delivery_setting = Object.assign({}, param.outer_plan_params.delivery_setting, { deep_bid_type })

          if (param.outer_plan_params.delivery_setting.deep_bid_type === 'DEEP_BID_MIN') {
            delete param.creative_params.roi_goal
          } else if (
            ['ROI_COEFFICIENT', 'FIRST_AND_SEVEN_PAY_ROI', 'PER_AND_SEVEN_PAY_ROI'].includes(
              param.outer_plan_params.delivery_setting.deep_bid_type
            )
          ) {
            delete param.creative_params.deep_cpabid
          } else if (param.outer_plan_params.delivery_setting.deep_bid_type === 'BID_PER_ACTION') {
            delete param.creative_params.roi_goal
            delete param.creative_params.deep_cpabid
          } else {
            delete param.outer_plan_params.delivery_setting.deep_bid_type
            delete param.creative_params.roi_goal
            delete param.creative_params.deep_cpabid
          }
          if (param.outer_plan_params.delivery_setting.bid_type === 'NO_BID') {
            delete param.creative_params.roi_goal
            delete param.creative_params.cpa_bid
            delete param.creative_params.deep_cpabid
          }

          // 不限预算处理
          if (param.outer_plan_params.delivery_setting.budget_mode === 'BUDGET_MODE_INFINITE') {
            delete param.outer_plan_params.delivery_setting.budget
          }

          // 广告潜力探索处理
          if (param.outer_plan_params.delivery_setting.bid_type === 'CUSTOM') {
            const { bid_type_upgrade } = param.outer_plan_params.delivery_setting
            param.outer_plan_params.delivery_setting.bid_type = bid_type_upgrade

            delete param.outer_plan_params.delivery_setting.bid_type_upgrade
          }

          // 根据竞价策略处理参数
          // 不是稳定成本的竞价策略 就不传投放速度
          if (param.outer_plan_params.delivery_setting.bid_type !== 'CUSTOM') {
            delete param.outer_plan_params.delivery_setting.bid_speed
          }
          // 不是最大转化的竞价策略 就不传预算择优分配（CBO）
          if (param.outer_plan_params.delivery_setting.bid_type !== 'NO_BID') {
            delete param.outer_plan_params.delivery_setting.budget_optimize_switch
          }

          // 择优预算开启时，预算传0
          if (param.outer_plan_params.delivery_setting.budget_optimize_switch === 'ON') param.creative_params.budget = 0

          if (param.inner_plan_params.ch_platform_id !== 3) delete param.outer_plan_params.micro_promotion_type
          if (param.inner_plan_params.ch_platform_id === 3) {
            const { landing_type } = param.inner_plan_params

            // 如果是小程序平台且推广目的是应用APP微端，删除micro_promotion_type
            if (landing_type === 'APP') {
              delete param.outer_plan_params.micro_promotion_type
            }
          }

          param = Object.assign(param, {
            ad_account_id: ret.account.id
          })

          // 删除项目层级的预算，在下面进行条件判断再添加
          delete param.outer_plan_params.delivery_setting.deep_cpabid
          delete param.outer_plan_params.delivery_setting.roi_goal
          delete param.outer_plan_params.delivery_setting.cpa_bid

          // 自动投放模式，项目出价参数处理
          if (delivery_mode === 'PROCEDURAL') {
            delete param.creative_params.budget
            delete param.creative_params.bid
            delete param.creative_params.cpa_bid
            delete param.creative_params.roi_goal
            delete param.creative_params.deep_cpabid

            // 自动投放模式，广告位置只能选择通投智选
            param.outer_plan_params.delivery_range.inventory_catalog = 'UNIVERSAL_SMART'
            delete param.outer_plan_params.delivery_range.inventory_type

            // 设置项目预算
            param.outer_plan_params.delivery_setting.budget = ret.budget.value

            // 当bid_type=NO_BID且BUDGET=BUDGET_MODE_DAY时,“预算择优分配”必填;
            if (param.outer_plan_params.delivery_setting.bid_type === 'NO_BID') {
              param.outer_plan_params.delivery_setting.budget_optimize_switch = 'ON'
            } else {
              param.outer_plan_params.delivery_setting.cpa_bid = Number(cpa_bid)
              if (['ROI_COEFFICIENT', 'FIRST_AND_SEVEN_PAY_ROI', 'PER_AND_SEVEN_PAY_ROI'].includes(deep_bid_type)) {
                param.outer_plan_params.delivery_setting.roi_goal = Number(roi_goal)
              }

              if (deep_bid_type === 'DEEP_BID_MIN') {
                param.outer_plan_params.delivery_setting.deep_cpabid = Number(deep_cpabid)
              }
            }
          }

          // 添加产品LOGO
          if (image_ids) {
            const hasLogo = param.creative_params.image_list.some((i) => i.image_mode === 'PRODUCT_LOGO')
            if (!hasLogo) {
              param.creative_params.image_list.push({
                image_mode: 'PRODUCT_LOGO',
                image_ids: [image_ids]
              })
            }
          } else {
            console.log('产品LOGO缺失')
          }

          // 抖音号
          if (aweme_id && awemeIdentity === 'AWEME') {
            param.creative_params = Object.assign(param.creative_params, {
              native_setting: {
                aweme_id,
                is_feed_and_fav_see,
                anchor_related_type
              }
            })
          }

          // 原生锚点
          if (anchor_id && anchor_related_type === 'SELECT') {
            param.creative_params = Object.assign(param.creative_params, {
              anchor_material_list: [
                {
                  anchor_type: 'APP_GAME',
                  anchor_id
                }
              ],
              anchor_name
            })
          }

          // 人群包更新
          param.targetings.targetingParam.audiences = ret.retarget.audiences
          // 媒体包更新
          param.targetings.targetingParam.mediaAudiences = ret.mediaAudiences
          param.targetings.targetingParam.flow_package = ret.mediaAudiences.flow_package
          param.targetings.targetingParam.exclude_flow_package = ret.mediaAudiences.exclude_flow_package

          isArray(param.targetings.targetingParam.action_scene) &&
            !param.targetings.targetingParam.action_scene.length &&
            (param.targetings.targetingParam.action_scene = ['E-COMMERCE', 'NEWS', 'APP'])
          // 设备类型
          !isArray(param.targetings.targetingParam.device_type) && delete param.targetings.targetingParam.device_type
          // 穿山甲
          if (
            param.targetings.targetingParam.inventory_type.length === 1 &&
            param.targetings.targetingParam.inventory_type.includes('INVENTORY_UNION_SLOT')
          ) {
            param.targetings.targetingParam.activate_type.includes('ONE_MONTH_2_THREE_MONTH') &&
              param.targetings.targetingParam.activate_type.splice(
                param.targetings.targetingParam.activate_type.indexOf('ONE_MONTH_2_THREE_MONTH'),
                1
              )
          } else {
            // 非穿山甲
            delete param.outer_plan_params.delivery_range.union_video_type
          }
          // if (param.outer_plan_params.download_type === 'EXTERNAL_URL') { // 落地页不区分平台版本
          //   param.targetings.targetingParam.android_osv && delete param.targetings.targetingParam.android_osv
          //   param.targetings.targetingParam.ios_osv && delete param.targetings.targetingParam.ios_osv
          // }
          param.targetings.targetingParam.article_category && delete param.targetings.targetingParam.article_category
          param.targetings.targetingParam.article && delete param.targetings.targetingParam.article
          delete param.targetings.targetingParam.retargeting_tags

          if (
            param.targetings.targetingParam.superior_popularity_type &&
            param.targetings.targetingParam.superior_popularity_type === 'CUSTOM'
          ) {
            delete param.targetings.targetingParam.superior_popularity_type
          } // 对于选择自定义媒体定向流量包，该字段不传

          // 平台仅选择iOS时，不传手机品牌
          if (
            param.targetings.targetingParam.platform &&
            isArray(param.targetings.targetingParam.platform) &&
            param.targetings.targetingParam.platform.includes('IOS') &&
            param.targetings.targetingParam.platform.length === 1
          ) {
            param.targetings.targetingParam.device_brand = []
          }
          // 平台为NONE时 全选不传
          if (param.targetings.targetingParam.platform && param.targetings.targetingParam.platform === 'NONE') {
            delete param.targetings.targetingParam.platform
          }

          // 自动投放模式设置定向参数，目前支持以下参数，详情看文档
          if (delivery_mode === 'PROCEDURAL') {
            const { age, district, city, gender, platform, hide_if_converted, audiences, location_type, android_osv, ios_osv } =
              param.targetings.targetingParam
            const proceduralParam = {
              age,
              district,
              gender,
              platform,
              hide_if_converted,
              audiences
            }

            const [platformText] = platform || []
            if (platformText === 'ANDROID') {
              proceduralParam.android_osv = android_osv
            }

            if (platformText === 'IOS') {
              proceduralParam.ios_osv = ios_osv
            }

            if (district !== 'NONE') {
              proceduralParam.city = city
              proceduralParam.location_type = location_type
            }
            param.targetings.targetingParam = proceduralParam
          }

          return param
        })
      })

      // 项目名称规则：
      // 1. 一对一 项目名称和广告名称保持一致
      // 2. 一对多 项目名称取同定向下的第一个，一个定向下都是同一个项目
      if (this.subject === 1) {
        params.planlist = params.planlist.map((item) => {
          return {
            ...item,
            campaign_params: {
              project_name: item.inner_plan_params.plan_name
            }
          }
        })
      } else {
        const result = params.planlist.reduce((acc, cur) => {
          const key = `${cur.targetings.targetingName}_${cur.ad_account_id}`
          if (!(key in acc)) {
            acc[key] = {
              campaign_params: {
                project_name: cur.inner_plan_params.plan_name
              },
              creative_name: cur.creative_params.campaign_name,
              items: [cur]
            }
          } else {
            acc[key].items.push(cur)
          }
          return acc
        }, {})

        for (const key in result) {
          const { campaign_params, items, creative_name } = result[key]
          for (const item of items) {
            item.campaign_params = campaign_params
            item.creative_params = {
              ...item.creative_params,
              creative_name
            }
          }
        }
      }
      this.loading = true
      addToutiaoBatchTaskSecond(params).then((data) => {
        if (typeof data !== 'symbol') this.loading = false
        if (data) {
          clearAllLocalforage(getSession('plan_timestamp'))
          clearSession()
          this.setOperatorStorage('operation', params.operation)
          this.disabled = true
          this.$Message.info({
            content: '提交成功！页面将 2 秒后自动关闭',
            duration: 2,
            onClose: () => {
              window.close()
            }
          })
        }
      })
    },
    back() {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>您正在编辑内容，离开将放弃原来的批量操作，确定要退出吗？</p>',
        loading: true,
        okText: '是',
        cancelText: '否',
        onOk: () => {
          timeout(300).then(() => {
            this.$Modal.remove()
            this.$router.push({
              name: 'localadt',
              query: { t: 'edit' }
            })
          })
        }
      })
    }
  },
  created() {
    this.getOperation()
    this.initSubmitData()
  }
}
</script>
<style lang="scss" scoped>
.c-betch {
  height: 100%;
  padding-bottom: 0;

  .m-bread {
    line-height: 20px;
    margin-bottom: 12px;
  }

  .module-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: calc(100% - 108px);

    .c-moduler {
      height: calc(100% - 12px);
      padding: 12px 16px;

      ::v-deep .c-moduler-range {
        height: 100%;

        > .c-moduler-title {
          margin-bottom: 8px;
        }
      }
    }
  }

  .c-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;

    .c-btns-submit {
      text-align: right;

      button {
        margin-left: 8px !important;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  .c-betch-head {
    font-size: 14px;
    color: #666;
    margin-bottom: 12px;

    span {
      line-height: 32px;
    }

    .c-submit-control {
      button {
        margin-left: 8px !important;
      }
    }
  }

  .c-betch-foot {
    line-height: 20px;
    display: inline-flex;
    align-items: center;

    .b-state {
      padding-right: 12px;
    }
  }
}
</style>
